import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-analyse',
  templateUrl: './info-analyse.component.html',
  styleUrls: ['./info-analyse.component.scss']
})
export class InfoAnalyseComponent implements OnInit {
  mode_add :number = 1;
  mode_madiv_ = 1;
  pdfSrc: string = "assets/file/analyse_prealable.pdf";
  pdfSrc2: string = "assets/file/preanalytique.pdf";
    pdfSrc3: string = "assets/file/liste_etablisment.pdf";
  
  constructor() { }

  ngOnInit() {
  }

  open(){
   this.mode_add = 1;
   console.log("1");
   this.mode_madiv_ = 1;
  }

  open2(){
    console.log("2");
    this.mode_add = 2;
    this.mode_madiv_ = 2;
   }

   open3(){
    this.mode_add = 3;
    this.mode_madiv_ = 2;
   }

}
